/**
 * My account, the B2B account and checkout are loaded on demand, from chunks
 * whose names carry a content hash. A deploy replaces them, so a tab opened
 * before it asks for files that no longer exist and the page would stay blank.
 * Vite reports that as `vite:preloadError`; reloading picks up the new build.
 *
 * Once per short window: if the chunk is still missing after a reload (a
 * broken deploy rather than a stale tab), the error is let through instead of
 * reloading forever.
 */

const RELOADED_AT_KEY = "wh-stale-chunk-reload-at";
export const STALE_CHUNK_RELOAD_WINDOW_MS = 10_000;

export function reloadOnStaleChunks(
  reload: () => void = () => window.location.reload()
): void {
  window.addEventListener("vite:preloadError", (event) => {
    try {
      const reloadedAt = Number(sessionStorage.getItem(RELOADED_AT_KEY));
      if (Date.now() - reloadedAt < STALE_CHUNK_RELOAD_WINDOW_MS) return;
      sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
    } catch {
      // No storage to remember the attempt in, so no loop guard: let it fail.
      return;
    }
    event.preventDefault();
    reload();
  });
}
